import { render, staticRenderFns } from "./187.vue?vue&type=template&id=5cb68b1b&scoped=true&"
var script = {}
import style0 from "./187.vue?vue&type=style&index=0&id=5cb68b1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb68b1b",
  null
  
)

export default component.exports